const ENStandards = {
	"Adicionar norma": "Add standard",
	"Alterar norma": "Change standard",
	"Criar nova norma": "Create new standard",
	"Deseja realmente excluir a norma": "Do you really want to delete the standard",
	"Erro ao adicionar norma": "Error on adding standard",
	"Erro ao alterar norma": "Error on changing standard",
	"Erro ao excluir norma": "Error on deleting standard",
	"Exclusão da norma": "Delete standard",
	"Descrição da norma é requerida": "Standard's description is required",
	"Nova norma": "New standard",
	"Norma adicionada com sucesso": "Standard successfully added",
	"Norma alterada com sucesso": "Standard successfully changed",
	"Normas de auditorias": "Audit standards",
	"Norma excluída com sucesso": "Standard successfully deleted",
	"Validade inicial":"Start expiration",
	"Validade final":"End expiration",
	"Data de Validade":"Expiration date",
	"Painel de Auditorias": "Audits Panel"
};

export default ENStandards;
